import { render, staticRenderFns } from "./NewJournalTicket.vue?vue&type=template&id=ee0b231c&scoped=true"
import script from "./NewJournalTicket.vue?vue&type=script&lang=js"
export * from "./NewJournalTicket.vue?vue&type=script&lang=js"
import style0 from "./NewJournalTicket.vue?vue&type=style&index=0&id=ee0b231c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0b231c",
  null
  
)

export default component.exports